<script lang="ts">
  import BadgeGridItem from '$lib/components/student/BadgeGridItem.svelte';

  import type { PageProps } from './$types';
  import { fade } from 'svelte/transition';
  let { data }: PageProps = $props();

  let isShowingBadge = $state(true);
  let badge: BadgeGridItem | null = $state(null);
</script>

<main class="container py-3" id="main-container">
  <h2>Animations</h2>
  <div class="d-flex gap-3">
    <button
      class="btn btn-primary"
      onclick={async () => {
        isShowingBadge = !isShowingBadge;
      }}>Toggle {isShowingBadge ? 'off' : 'on'}</button
    >
    <button class="btn btn-primary" onclick={() => badge?.launchAnimation()}> Confetti </button>
  </div>
  <div class="badge-grid">
    {#await data.classPromise then lbdetail}
      {#if isShowingBadge}
        <div transition:fade>
          <BadgeGridItem
            bind:this={badge}
            category={lbdetail.class.course.skillCategories[0]}
            completedSkillCount={0}
            possibleSkillCount={3}
            animateOnMount
          />
        </div>
      {/if}
    {/await}
  </div>
</main>

<style>
  .badge-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    gap: 2rem;
    min-height: 200px;
  }
</style>
